/* =============================================================================
   ANTISPAM DE FORMULARIOS
   -----------------------------------------------------------------------------
   Dos capas, las dos gratuitas:

   1. HONEYPOT. Un campo de texto que el usuario no ve pero el bot sí. Si llega
      relleno, el envío se descarta sin avisar. Se manda además como _gotcha,
      que es el nombre que Formspree reconoce por su cuenta.

   2. CLOUDFLARE TURNSTILE. Un captcha que casi nunca pide interacción. El
      widget genera un token y lo mandamos como cf-turnstile-response.
      IMPORTANTE: quien comprueba ese token es Formspree, no la web. Hay que
      activar CAPTCHA en los ajustes del formulario en Formspree y pegar ahí el
      Secret Key de Cloudflare. Sin ese paso, el captcha es decorativo: quien
      encuentre el endpoint en el JS puede seguir enviando.

   Mientras SITE.turnstileSiteKey esté vacío el captcha no se pinta y los
   formularios funcionan exactamente igual que antes. El honeypot sí actúa desde
   el primer momento.

   USO EN UN FORMULARIO
     import captcha from '@/mixins/captcha';
     mixins: [captcha]

     <input v-model="honeypot" class="gr-hp" type="text" name="_gotcha"
            tabindex="-1" autocomplete="off" aria-hidden="true">
     <captcha-turnstile ref="captcha" :site-key="captchaSiteKey" :lang="lang"
                        @token="onCaptchaToken" />

     if (this.esSpam()) { ...simular éxito y salir... }
     if (this.captchaPendiente()) { ...pedir que espere un segundo... }
     body: JSON.stringify(Object.assign({}, payload, this.camposAntispam()))
     ...y this.reiniciarCaptcha() al terminar
   ============================================================================= */

import site from '@/content/site';
import CaptchaTurnstile from '@/components/CaptchaTurnstile';

var SITE = site.SITE || site;

export default {
  components: { CaptchaTurnstile },

  data: function () {
    return {
      honeypot: '',
      captchaToken: ''
    };
  },

  computed: {
    captchaSiteKey: function () {
      return (SITE && SITE.turnstileSiteKey) || '';
    },

    captchaActivo: function () {
      return !!this.captchaSiteKey;
    }
  },

  methods: {
    onCaptchaToken: function (token) {
      this.captchaToken = token || '';
    },

    /* El bot ha rellenado el campo trampa */
    esSpam: function () {
      return !!(this.honeypot && String(this.honeypot).trim());
    },

    /* Hay captcha configurado pero todavía no ha devuelto token. Pasa si el
       usuario envía en el primer segundo o si Cloudflare no ha cargado. */
    captchaPendiente: function () {
      return this.captchaActivo && !this.captchaToken;
    },

    /* Campos que se añaden al cuerpo del envío */
    camposAntispam: function () {
      var extra = { _gotcha: '' };
      if (this.captchaActivo) extra['cf-turnstile-response'] = this.captchaToken;
      return extra;
    },

    /* El token es de un solo uso: tras cada envío hay que pedir otro */
    reiniciarCaptcha: function () {
      this.captchaToken = '';
      if (this.$refs.captcha && this.$refs.captcha.reiniciar) {
        this.$refs.captcha.reiniciar();
      }
    }
  }
};
